export default __webpack_public_path__ + "static/media/1.6b38f9f3.jpg";